import LinkIcon from '@mui/icons-material/Link';
import { Grid, Typography } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import usePaymentLink from './hooks/usePaymentLink.service';
import PaymentLinkButtonStyles from './PaymentLinkButton.style';

const PaymentLinkButton = () => {
  const { t } = useTranslation();

  const { onNavigate } = usePaymentLink();

  return (
    <Grid item xs={12} lg={6}>
      <button
        id="paymentLinkButton"
        type="button"
        onClick={() => onNavigate()}
        className={clsx(
          'fourth-step paymentLinkButton',
          PaymentLinkButtonStyles.wrapper
        )}
      >
        <div className={PaymentLinkButtonStyles.content}>
          <div className={PaymentLinkButtonStyles.iconWrapper}>
            <LinkIcon className={PaymentLinkButtonStyles.icon} />
          </div>
          <div className={PaymentLinkButtonStyles.textWrapper}>
            <Typography
              variant="subtitle2"
              className={PaymentLinkButtonStyles.contentTitle}
            >
              {t('plbBadge')}
            </Typography>
            <Typography
              variant="body1"
              className={PaymentLinkButtonStyles.contentMessage}
            >
              {t('plbTitle')}
            </Typography>
          </div>
        </div>
      </button>
    </Grid>
  );
};

export default PaymentLinkButton;
